import { buildCatalogueGoogleSearchUrlFromParts } from "@/lib/catalogueGoogleSearch";

/**
 * `descriptionSnapshot` is built as blocks separated by blank lines (see `buildProposalDescriptionSnapshot`).
 */
export function parseProposalLineSnapshot(snapshot: string) {
  const parts = snapshot
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean);
  const title = parts[0] ?? "";
  const brandModel = parts[1] ?? "";
  const meta: { sku?: string; uom?: string; finish?: string } = {};
  const narrative: string[] = [];
  for (let i = 2; i < parts.length; i++) {
    const p = parts[i] ?? "";
    if (/^SKU:\s*/i.test(p)) meta.sku = p.replace(/^SKU:\s*/i, "").trim();
    else if (/^UOM:\s*/i.test(p)) meta.uom = p.replace(/^UOM:\s*/i, "").trim();
    else if (/^Finish:\s*/i.test(p)) meta.finish = p.replace(/^Finish:\s*/i, "").trim();
    else narrative.push(p);
  }
  return { title, brandModel, narrative: narrative.join("\n\n").trim(), meta };
}

export function buildProposalSupportLinks(
  line: ReturnType<typeof parseProposalLineSnapshot>,
  item?: { brand?: string | null; model?: string | null },
) {
  const brandModelParts = line.brandModel.split("·").map((p) => p.trim()).filter(Boolean);
  const brand = item?.brand?.trim() || brandModelParts[0] || "";
  const model = item?.model?.trim() || brandModelParts.slice(1).join(" ") || brandModelParts[0] || "";
  const parts = { brand, model, displayName: line.title || line.brandModel };
  return {
    brochure: buildCatalogueGoogleSearchUrlFromParts(parts, "brochure"),
    specs: buildCatalogueGoogleSearchUrlFromParts(parts, "spec"),
    reviews: buildCatalogueGoogleSearchUrlFromParts(parts, "review"),
  } as const;
}
